/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: enrolments.Unenrolment.
export default class Unenrolment extends Model {
  declare [Type]: 'enrolments/unenrolment';

  @attr()
  declare nzMoe: unknown;

  @computed('nzMoe')
  get nzMoeText() {
    return JSON.stringify(this.nzMoe);
  }
}
